module.exports = __webpack_public_path__ + "img/duration.ab766c60.svg";